import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Drawer from '@components/Drawer';
import { useTranslation } from '@hooks';
import SubscriptionCard from './SubscriptionCard';
import { getEntitledSubscriptions } from '@helpers/billing';
import { BILLING_TYPE_MAP } from '@constants/billing';

const CustomSubscriptionDrawer = ({ title, primaryAction, actionDisabled, open, onClose }) => {
    const { t } = useTranslation();
    const [selectedSubscription, setSubscription] = useState({});

    const account = useSelector(state => state.account?.account);
    const subscriptions = getEntitledSubscriptions(account).filter(
        item => item.billingPlanName !== BILLING_TYPE_MAP.FREEMIUM && item.billingPlanName !== BILLING_TYPE_MAP.TRIAL,
    );

    useEffect(() => {
        if (subscriptions.length && !subscriptions.some(item => item.id === selectedSubscription.id)) {
            setSubscription(subscriptions[0]);
        }
    }, [subscriptions, selectedSubscription.id]);

    const onSubmit = async () => primaryAction(selectedSubscription.id);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            title={title}
            primaryText={t('buttons.continue')}
            primaryDisabled={actionDisabled}
            primaryAction={onSubmit}
        >
            <div style={{ display: 'grid', gridGap: '8px' }}>
                {subscriptions.length > 0 &&
                    subscriptions.map(item => (
                        <SubscriptionCard
                            key={item.id}
                            subscription={item}
                            selectedSubscription={selectedSubscription}
                            setSubscription={() => setSubscription(item)}
                        />
                    ))}
            </div>
        </Drawer>
    );
};

export default CustomSubscriptionDrawer;
